import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-left: auto;

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;

    li {
      a {
        padding: 18px 20px;
        display: block;
        text-decoration: none;
        color: ${props => props.theme.palette.general.strong};
        transition: all ease-in-out 0.3s;

        &:hover {
          color: ${props => props.theme.palette.primary.alphaDark};
        }
      }
    }
  }
`
